module.exports = __webpack_public_path__ + "img/socotra-logo-with-name.cafe6283.png";